import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import actions from '../constants';

export function* toggleAnnouncements() {
  yield call(listener.toggleAnnouncements);
}

export default function* announcementsLayout() {
  yield takeEvery([actions.SHOW_ANNOUNCEMENTS, actions.CLOSE_ANNOUNCEMENTS], toggleAnnouncements);
}
